import React from "react";
import Button from "./Button";
import useDarkMode from "../hooks/useDarkMode";
import { useFormCtx } from "./../FormContext";
import * as Const from "./../_Const";

const DebugPage = ({ terminal, uid, keyNumber }) => {
  const {
    handleDebug,
    navigateToServicePage,
    handleAnimationDisabled,
    isAnimationDisabled,
    setDarkMode,
    runRestartOrShutdown,
    isSoundEnabled,
    setSoundEnabledApi,
    isPhotoCaptureTestEnabled,
    setPhotoCaptureTestEnabledApi,
    isWithoutCardEnabled,
    setWithouCardApi,
    eraseTerminalLog,
    isCursorEnabled,
    setCursorEnabledApi,
  } = useFormCtx();
  const [isDarkMode, toggleTheme] = useDarkMode();
  const textAnimation = isAnimationDisabled ? "Animace - Zapnout" : "Animace - Vypnout";
  const textSound = isSoundEnabled ? "Zvuk - Vypnout" : "Zvuk - Zapnout";
  const textCursor = isCursorEnabled ? "Myš kurzor - Vypnout" : "Myš kurzor - Zapnout";
  const textDarkLightMode = isDarkMode ? "Nastavit Světlý řežim" : "Nastavit Tmavý řežim";
  const textCameraTest = isPhotoCaptureTestEnabled ? "Kamera Test - Vypnout" : "Kamera Test - Zapnout";
  const textPatWithoutCard = isWithoutCardEnabled ? "Pac. bez průkazu - Vypnout" : "Pac. bez průkazu - Zapnout";

  function handleDarkMode() {
    setDarkMode(!isDarkMode);
    toggleTheme();
  }

  function closeDebug() {
    window.location.reload();
  }

  return (
    <>
      <div className="mt-2 gap-2 mx-2 scRPIV2:mt-6 scRPIV2:gap-4 scRPIV2:mx-4 scWaveShare:mt-6 scWaveShare:gap-4 scWaveShare:mx-4 tvHD:mt-6 tvHD:gap-4 tvHD:mx-4  tvFullHD:mt-6  tvFullHD:gap-4  tvFullHD:mx-8  tv4K:mt-12  tv4K:gap-8  tv4K:mx-12  grid grid-cols-4">
        <Button
          title="HW SW info"
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={() => navigateToServicePage(Const.PAGE_HW_SW_INFO)}
        />
        <Button
          title="Log terminálu"
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={() => navigateToServicePage(Const.PAGE_ERROR_LOG_TERMINAL)}
        />
        <Button
          title="Log web aplikace"
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={() => navigateToServicePage(Const.PAGE_ERROR_LOG)}
        />
        <Button
          title="Nastavení kamery"
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={() => navigateToServicePage(Const.PAGE_CAMERA_TEST)}
        />
        {/* <Button title="Test Page" showIcon={false} className={`${getCssFor("btn")}`} onClick={() => navigateToServicePage(Const.PAGE_TEST)} /> */}
      </div>
      <div className="mt-2 gap-2 mx-2 scRPIV2:mt-6 scRPIV2:gap-4 scRPIV2:mx-4 scWaveShare:mt-6 scWaveShare:gap-4 scWaveShare:mx-4 tvHD:mt-6 tvHD:gap-4 tvHD:mx-4  tvFullHD:mt-6  tvFullHD:gap-4  tvFullHD:mx-8  tv4K:mt-6  tv4K:gap-8  tv4K:mx-12  grid grid-cols-4">
        <Button
          title={textCameraTest}
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={async () => await setPhotoCaptureTestEnabledApi(!isPhotoCaptureTestEnabled)}
        />
        <Button
          title={textSound}
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={async () => await setSoundEnabledApi(!isSoundEnabled)}
        />
        <Button
          title={textDarkLightMode}
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={handleDarkMode}
        />
        <Button
          title={textPatWithoutCard}
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={async () => await setWithouCardApi(!isWithoutCardEnabled)}
        />
      </div>
      <div className="mt-2 gap-2 mx-2 scRPIV2:mt-6 scRPIV2:gap-4 scRPIV2:mx-4 scWaveShare:mt-6 scWaveShare:gap-4 scWaveShare:mx-4 tvHD:mt-6 tvHD:gap-4 tvHD:mx-4  tvFullHD:mt-6  tvFullHD:gap-4  tvFullHD:mx-8  tv4K:mt-6  tv4K:gap-8  tv4K:mx-12  grid grid-cols-4">
        <Button
          title="Testování zvuk/led"
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={() => navigateToServicePage(Const.PAGE_TEST_SOUND_LED)}
        />
        <Button
          title="Jas dipsleje"
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={() => navigateToServicePage(Const.PAGE_BRIGHTNESS)}
        />
        <Button
          title={textCursor}
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={async () => await setCursorEnabledApi(!isCursorEnabled)}
        />
        <Button
          title={textAnimation}
          showIcon={false}
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
          onClick={() => handleAnimationDisabled(!isAnimationDisabled)}
        />
      </div>

      <div className="gap-2 left-2 right-2 scRPIV2:gap-4 scRPIV2:left-4 scRPIV2:right-4 scWaveShare:gap-4 scWaveShare:left-4 scWaveShare:right-4 tvHD:gap-4 tvHD:left-4 tvHD:right-4 tvFullHD:gap-4 tvFullHD:left-8 tvFullHD:right-8 tv4K:gap-8 tv4K:left-12 tv4K:right-12 grid grid-cols-4 absolute bottom-8">
        <Button
          title="Vypnout"
          showIcon={false}
          type="clickonce-red"
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-32 tvFullHD:text-2xl tv4K:h-60 tv4K:text-6xl"
          onClick={() => runRestartOrShutdown(Const.OPERATION_SHUTDOWN)}
        />
        <Button
          title="Restart"
          showIcon={false}
          type="clickonce-red"
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-32 tvFullHD:text-2xl tv4K:h-60 tv4K:text-6xl"
          onClick={() => runRestartOrShutdown(Const.OPERATION_RESTART)}
        />
        <div className=""></div>
        <Button
          title="Ukončit DEBUG Mode"
          type="error-dark"
          className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-32 tvFullHD:text-2xl tv4K:h-60 tv4K:text-6xl"
          showIcon={false}
          onClick={() => closeDebug()}
        />
      </div>
    </>
  );
};

export default DebugPage;
